import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
// import "./style/resrt.css";
import { getJWT } from "./api/constant";


//ElementUI组件
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
// 注册滑块验证码
// import SlideVerify from "vue-monoplasty-slide-verify";
// Vue.use(SlideVerify);
// import dragVerify from "vue-drag-verify2";
// Vue.use(dragVerify);

//时间转换
import moment from "moment";
Vue.prototype.$moment = moment;

// 注册全局过滤器
import * as custom from "./api/filter";
Object.keys(custom).forEach((key) => {
  Vue.filter(key, custom[key]);
});

// 全局小写转大写过滤器
Vue.filter("datesmall", function (value) {
  if (!value) return ""; // 当传入的value为null，则返回空字符串
  value = value.toString(); // 将传入的value转为String类型
  return value.toUpperCase();
});

Vue.config.productionTip = false;
import register from "./assets/js/registerDialog.js"; // 登录弹窗全局组件
import login from "./assets/js/loginDialog.js";
Vue.prototype.$login = login.install; // 全局可使用this.$login调用
Vue.prototype.$register = register.install; // 全局可使用this.$login调用

Vue.prototype.$store = store;

// 全局定义禁止输入特殊字符
Vue.prototype.$validForbid = function (value) { value = value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '').replace(/\s/g, ""); return value; }


// 路由守卫
router.beforeEach((to, from, next) => {
  if (getJWT() && getJWT() != "") {
    next();
  } else {
    if (to.meta.requireAuth) {
      // next({ path: "/" });
      login.install({
        login: (data) => {
          if (data) {
            store.commit("setUser", data);
          }
        },
      });
    } else {
      next();
    }
  }
});

// Vue.prototype.$router = router;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
